export const getPasswordRequirements = ({ password, email }: { password: string; email?: string | null }) => {
  const isLongEnoughPassword = password.length >= 8;
  const isNotTooLong = password.length <= 100;

  const requirements = [
    {
      summary: 'Contain at least one number (0-9)',
      isMatched: /[0-9]+/.test(password),
    },
    {
      summary: 'Contain at least one lowercase letter (a-z)',
      isMatched: /[a-z]+/.test(password),
    },
    {
      summary: 'Contain at least one uppercase letter (A-Z)',
      isMatched: /[A-Z]+/.test(password),
    },
    {
      summary: 'Contain at least one symbol (!@#$%^&*_-+<>?/)',
      isMatched: /[!@#$%^&*_\-+=<>?/]+/.test(password),
    },
    {
      summary: 'Not contain your email',
      isMatched: isLongEnoughPassword && email ? !password.includes(email) : false,
    },
    {
      summary: 'Be at least 8 characters long',
      isMatched: isLongEnoughPassword,
    },
  ];

  const isPasswordValid = requirements.every((requirement) => requirement.isMatched) && isNotTooLong;

  return {
    requirements,
    isPasswordValid,
  };
};
